import script from "./esConsultationDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./esConsultationDetails.vue?vue&type=script&setup=true&lang=ts"

import "./esConsultationDetails.vue?vue&type=style&index=0&id=e7f35174&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7f35174"]])

export default __exports__